<template>
  <el-dialog
    title="查看详情"
    :visible.sync="visible"
    width="900px"
    class="dialog"
    :close-on-click-modal="false"
  >
    <el-descriptions title="评委信息" direction="vertical" :column="3" border>
      <el-descriptions-item label="专家姓名">
        {{ info.expertName || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="联系电话">
        {{ info.expertMobile || '-' }}
      </el-descriptions-item>
      <!--<el-descriptions-item label="所在单位">-->
      <!--  {{ info.companyName || '-' }}-->
      <!--</el-descriptions-item>-->
      <!--<el-descriptions-item label="职称">-->
      <!--  {{ jobTitleDict.translate(reviewerDetail.jobTitle).label || '-' }}-->
      <!--</el-descriptions-item>-->
      <el-descriptions-item label="是否为招标人评委">
        {{ whetherDict.translate(info.isPurchaseExpert).label || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="登录账号">
        {{ info.expertMobile || '-' }}
      </el-descriptions-item>
    </el-descriptions>
  </el-dialog>
</template>

<script>
import { whetherDict } from '@/dictionary/project/common'

export default {
  name: 'OnlineReviewerInfoDialog',

  data() {
    return {
      visible: false,

      info: {},

      whetherDict
    }
  },

  methods: {
    openDialog(data) {
      this.visible = true
      this.info = data
    },

    closeDialog() {
      this.visible = false
    }
  }
}
</script>

<style scoped lang="scss"></style>
